<template>
  <pdf-app
    v-if="pdf"
    v-show="isPagesRendered"
    :pdf="pdf"
    :file-name="fileName ? `${fileName}.pdf` : undefined"
    locale="ru"
    @pages-rendered="onPagesRendered"
  />
  <page-content-placeholder v-if="!isPagesRendered" :img-src="DocumentsPlaceholderImage" text="Загружаю PDF..." />
</template>

<script lang="ts" setup>
import { nextTick, ref, watch } from 'vue';
import PdfApp from 'vue3-pdf-app';
import 'vue3-pdf-app/dist/icons/main.css';
import DocumentsPlaceholderImage from '@/assets/img/pages/documents/documents-placeholder.svg';
import PageContentPlaceholder from '@/core/components/common/PageContentPlaceholder.vue';

const props = defineProps<{
  src: Blob | string | null;
  fileName?: string;
}>();

const prevPdf = ref<ArrayBuffer | string | null>(null);
const pdf = ref<ArrayBuffer | string | null>(null);
const isPagesRendered = ref(false);

watch(
  () => props.src,
  async () => {
    if (props.src instanceof Blob) {
      const arr = await props.src.arrayBuffer();

      await nextTick();
      pdf.value = arr;
      prevPdf.value = arr;
    } else {
      pdf.value = props.src;
    }
  },
  {
    immediate: true,
  },
);

const onPagesRendered = () => {
  isPagesRendered.value = true;
};
</script>

<style lang="scss" scoped></style>
